import React, { Component, useEffect, useState, useRef } from 'react'
import { Fade } from 'react-slideshow-image'
import InfiniteScroll from 'react-infinite-scroller'
import ImageGallery from 'react-image-gallery'
import Divider from '@material-ui/core/Divider'
import Img3 from 'components/img3'
import Img from 'components/img'
import { NavLink } from 'react-router-dom'
import VideoPlayer from 'react-video-markers'
import { HorizontalSwiper } from 'components/Swiper'
import './imageCarousel.css'
import FrontStream from 'containers/FrontPgStream'
import Season from './FrontPages/Season'
import Swiper from 'react-id-swiper'
import Carousel from 'react-bootstrap/Carousel'
import Scrollbars from 'components/CustomScrollBar'
import Vid from './FrontPages/Vid'
import DesignerTab from './FrontPages/DesignerTab'
import MobileFront from './MobileFront'
import { SidewaysDisplay, HeaderDisplay } from 'containers/Stream2'
import UserBoxListComponent2 from 'components/findpeople2'
import 'swiper/dist/css/swiper.min.css'

var FaceLeaf = require('./images/LeafFace.jpg')
var Log = require('./images/karin_photo.jpg')
var Fall = require('./images/b&w.jpg')
var bg = require('./images/fall_vibes.jpg')
let icon = require('../assets/next_icon.svg')
let Previcon = require('../assets/prev_icon.svg')
let arrow = require('../assets/Right_arrow.png')

const HorizontalSwiperParams = {
  pagination: {
    el: '.swiper-pagination.swiper-pagination-h',
    clickable: true
  }
}
const pages = ['Costumes', 'Fall', 'Designers']
const params = {
  slidesPerView: 1,
  spaceBetween: 5,
  slidesPerGroup: 1,
  loop: false,
  loopFillGroupWithBlank: false,
  initialSlide: 1,
}

export const ImageCarousel = () => {
  const [pageHeight, SetHeight] = useState(window.innerHeight)
  let ref = useRef(null)
  useEffect(() => {
    window.addEventListener(onresize, () => {
      SetHeight(window.innerHeight)
    });


    // return function cleanup() {
    //   window.removeEventListener(onresize)
    // }
  })
  const goNext = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slideNext();
    }
    let num = ref.current.swiper.realIndex
    // alert(ref.current.swiper.realIndex)
    // SetIndex(num)
  };

  const goPrev = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slidePrev();
    }
    let num = ref.current.swiper.realIndex
    // SetIndex(num)

  };
  if (window.outerWidth > 500) {
    return (
      // <Scrollbars style={{width: '100px'}}>
      <div className={'vertSwipe'} style={window.outerWidth > 500 ? { marginTop: '0%', msScrollbarBaseColor: 'yellow', backgroundColor: 'white' } : { marginTop: '0px', backgroundColor: 'white' }}>

        {/* <Swiper style={{ width: '100%' }} ref={ref} {...params}> */}
        <div>
          <div style={{ width: '100%', maxWidth: '100%', paddingBottom: '3vh' }}>
            <HeaderDisplay
              URL='https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/images%2Fremove%20background%20shoes.png?alt=media&token=b01a9861-9947-47ba-ad7b-98656f7bdcca'
              Type={`Yeezy Boost 350 V2 'Black'`}
              backgroundColor='black'>
            </HeaderDisplay>

          </div>
          <div className='Directory_Wording' style={{ width: '90%', margin: 'auto' }}>
            <div style={{ float: 'left' }}>Latest Drops </div>
            <img style={{ maxWidth: '100%', width: '3%', float: 'right' }} src={arrow}></img>
          </div>
          <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '40px 0px 12vh 20px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
            <SidewaysDisplay objectFit={'contain'} Type={'Sneakers'} />
          </div>

          {/* <div style={{backgroundColor: 'red', height: '50px'}}>
          <UserBoxListComponent2/>
          </div> */}

          <div className='Directory_Wording' style={{ width: '90%', margin: 'auto' }}>
            <div style={{ float: 'left' }}>Skin Essentials </div>
            <img style={{ maxWidth: '100%', width: '3%', float: 'right', }} src={arrow}></img>
          </div>
          <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '40px 0px 12vh 0px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
            <SidewaysDisplay objectFit='cover' Type={'Skincare'} />
          </div>
          <div style={{ width: '100%', maxWidth: '100%' }}>
            <HeaderDisplay
              URL='https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/images%2Fhandsome-african-american-guy-wear-military-jacket-SENP55A%20(1).jpg?alt=media&token=9f22eb45-4d89-4e68-b376-4a0d34e0c477'
            // Type={`Art Through Streetwear`}
            >
            </HeaderDisplay>

          </div>
          <div className='Directory_Wording' style={{ width: '90%', margin: 'auto', marginTop: '5vh' }}>
            <div style={{ float: 'left' }}> Streetwear</div>
            <img style={{ maxWidth: '100%', width: '3%', float: 'right', }} src={arrow}></img>
          </div>
          <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '40px 0px 20px 0px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
            <SidewaysDisplay objectFit='cover' SearchType='ByUser' userId={'oNmyjhFaf8boUJrRrP4i2GHK8Gr1'} />
          </div>

          <div className='Directory_Wording' style={{ width: '90%', margin: 'auto' }}>
            <div style={{ float: 'left' }}> Selling Fast</div>
            <img style={{ maxWidth: '100%', width: '3%', float: 'right', }} src={arrow}></img>
          </div>
          <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '40px 0px 20px 0px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
            <SidewaysDisplay objectFit={'cover'} Type='Hats' />
          </div>

          <div style={{ width: '100%', maxWidth: '100%' }}>
            <HeaderDisplay
              URL='https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2FCJ%20Shirts.jpg?alt=media&token=eaf2b0d2-c74e-4c7e-aade-590dccda80ba'
            // Type={`Art Through Streetwear`}
            >
            </HeaderDisplay>
            <div className='Directory_Wording' style={{ width: '90%', margin: 'auto' }}>
              <div style={{ float: 'left' }}> Up & Coming</div>
              <img style={{ maxWidth: '100%', width: '3%', float: 'right', }} src={arrow}></img>
            </div>
            <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '40px 0px 20px 0px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
              <SidewaysDisplay SearchType='ByUser' userId={'q8moxPlMd8Zu6AjP6dz902oFT242'} />
            </div>
          </div>
        </div>


        {/* <div className='Directory_Wording' style={{ width: '90%', margin: 'auto' }}>
            <div style={{ float: 'left' }}>Product Drops </div>
            <img style={{ maxWidth: '100%', width: '10%', float: 'right' }} src={arrow}></img>
          </div>
          <div style={{ color: '#777', backgroundColor: 'white', textalign: 'center', padding: '50px 0px', textAlign: 'justify', margin: '0 5% 0 5%' }}>
            <SidewaysDisplay Type={'Skincare'} />
          </div> */}

        {/* </Swiper> */}
        <div className={'next_icon'}></div>

      </div>
      // </Scrollbars>
    )
  } else {
    return (
      <MobileFront />
    )
  }
}

export default ImageCarousel


// WEBPACK FOOTER //
// ./src/containers/FrontPg/ImageCarousel/promopg.jsx